import Breadcrumb from '../components/sections/Breadcrumb';

const Disclaimer = () => {
  const termsData = [
    {
      number: 1,
      title: 'Acceptance of Terms',
      content: 'By accessing and using the Tanzania Digital Awards website and participating in our awards program, you accept and agree to be bound by these Terms and Conditions.'
    },
    {
      number: 2,
      title: 'Eligibility',
      content: 'Participation in the Tanzania Digital Awards is open to individuals and organizations that meet the eligibility criteria specified for each award category. All nominees must have a demonstrable presence or impact in Tanzania\'s digital landscape.'
    },
    {
      number: 3,
      title: 'Nomination Process',
      content: 'When submitting a nomination:',
      list: [
        'All information provided must be accurate and truthful',
        'You must have permission to nominate on behalf of another party',
        'Nominations become the property of Tanzania Digital Awards',
        'Multiple nominations in the same category may be disqualified',
        'The organizing committee reserves the right to move nominations between categories'
      ]
    },
    {
      number: 4,
      title: 'Voting and Selection',
      content: 'The judging process combines public voting and expert panel evaluation. The organizing committee reserves the right to verify votes and disqualify fraudulent voting activities. All judging decisions are final and binding.'
    },
    {
      number: 5,
      title: 'Intellectual Property',
      content: 'All content on this website, including text, graphics, logos, and software, is the property of Tanzania Digital Awards or its content suppliers and is protected by intellectual property laws.'
    },
    {
      number: 6,
      title: 'Use of Submissions',
      content: 'By submitting nominations or other content, you grant Tanzania Digital Awards a non-exclusive, worldwide, royalty-free license to use, reproduce, and display such content for promotional and award-related purposes.'
    },
    {
      number: 7,
      title: 'Limitation of Liability',
      content: 'Tanzania Digital Awards, its organizers, partners, and sponsors shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of this website or participation in the awards program.'
    },
    {
      number: 8,
      title: 'Disclaimer of Warranties',
      content: 'This website and the awards program are provided "as is" without any warranties, express or implied. We do not warrant that the website will be uninterrupted or error-free.'
    },
    {
      number: 9,
      title: 'Changes to Terms',
      content: 'We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting to the website. Your continued use constitutes acceptance of modified terms.'
    },
    {
      number: 10,
      title: 'Governing Law',
      content: 'These Terms and Conditions are governed by and construed in accordance with the laws of the United Republic of Tanzania.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb title="Terms & Conditions" subtitle="DISCLAIMER" />

      <section 
        className="py-16 md:py-20 bg-white"
        style={{
          padding: '4rem 0',
          backgroundColor: '#ffffff'
        }}
      >
        <div 
          className="container mx-auto px-6 md:px-8 lg:px-12" 
          style={{ 
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1.5rem'
          }}
        >
          <div 
            className="max-w-4xl mx-auto"
            style={{
              maxWidth: '56rem',
              margin: '0 auto'
            }}
          >
            {/* Header Section */}
            <div 
              className="mb-12 text-center"
              style={{
                marginBottom: '3rem',
                textAlign: 'center'
              }}
            >
              <div 
                className="inline-flex items-center px-4 py-2 rounded-full mb-6"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '0.5rem 1rem',
                  borderRadius: '9999px',
                  backgroundColor: '#FFF7ED',
                  border: '2px solid #ffba17',
                  marginBottom: '1.5rem'
                }}
              >
                <i 
                  className="fa-solid fa-file-contract mr-2"
                  style={{
                    color: '#ffba17',
                    marginRight: '0.5rem',
                    fontSize: '1.125rem'
                  }}
                ></i>
                <span 
                  className="text-sm font-semibold uppercase tracking-wider"
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    color: '#ffba17'
                  }}
                >
                  Terms & Conditions
                </span>
              </div>
              <p 
                className="text-gray-500 text-sm"
                style={{
                  color: '#6B7280',
                  fontSize: '0.875rem',
                  marginTop: '1rem'
                }}
              >
                Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>

            {/* Content Sections */}
            <div className="space-y-10">
              {termsData.map((section, idx) => (
                <div 
                  key={section.number}
                  className={idx % 2 === 0 ? "bg-white border-l-4 pl-6 py-4" : "bg-gray-50 rounded-xl p-6 md:p-8"}
                  style={idx % 2 === 0 ? {
                    backgroundColor: 'white',
                    borderLeft: '4px solid #ffba17',
                    paddingLeft: '1.5rem',
                    paddingTop: '1rem',
                    paddingBottom: '1rem'
                  } : {
                    backgroundColor: '#F9FAFB',
                    borderRadius: '0.75rem',
                    padding: '2rem'
                  }}
                >
                  <h2 
                    className="text-2xl md:text-3xl font-bold mb-4"
                    style={{
                      fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                      fontWeight: '700',
                      color: '#0f1b3c',
                      marginBottom: '1rem'
                    }}
                  >
                    <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>{section.number}.</span>
                    {section.title}
                  </h2>
                  <p 
                    className="text-gray-600 leading-relaxed"
                    style={{
                      color: '#4B5563',
                      lineHeight: '1.8',
                      fontSize: '1.0625rem',
                      marginBottom: section.list ? '1rem' : '0'
                    }}
                  >
                    {section.content}
                  </p>
                  {section.list && (
                    <ul className="space-y-3" style={{ marginTop: '1rem' }}>
                      {section.list.map((item, index) => (
                        <li 
                          key={index} 
                          className="flex items-start"
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start'
                          }}
                        >
                          <i 
                            className="fa-solid fa-check-circle mt-1 mr-3"
                            style={{
                              color: '#ffba17',
                              marginTop: '0.25rem',
                              marginRight: '0.75rem',
                              flexShrink: '0'
                            }}
                          ></i>
                          <span 
                            className="text-gray-600 leading-relaxed"
                            style={{
                              color: '#4B5563',
                              lineHeight: '1.75',
                              fontSize: '1rem'
                            }}
                          >
                            {item}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {/* Contact Section */}
              <div 
                className="rounded-xl p-8 md:p-10"
                style={{
                  background: 'linear-gradient(135deg, #0f1b3c 0%, #1a2d5c 100%)',
                  borderRadius: '0.75rem',
                  padding: '2.5rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4 text-white"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: 'white',
                    marginBottom: '1rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-envelope mr-3"
                    style={{
                      color: '#ffba17',
                      marginRight: '0.75rem'
                    }}
                  ></i>
                  Contact Information
                </h2>
                <p 
                  className="text-gray-300 mb-6 leading-relaxed"
                  style={{
                    color: '#D1D5DB',
                    marginBottom: '1.5rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  For questions about these Terms and Conditions, please contact:
                </p>
                <div className="space-y-4">
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-envelope mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Email
                      </p>
                      <a 
                        href="mailto:info@digitalawards.co.tz"
                        className="text-white hover:text-gold transition-colors"
                        style={{
                          color: 'white',
                          textDecoration: 'none',
                          fontSize: '1.0625rem',
                          cursor: 'pointer'
                        }}
                      >
                        info@digitalawards.co.tz
                      </a>
                    </div>
                  </div>
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-phone mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Phone
                      </p>
                      <p 
                        className="text-white"
                        style={{
                          color: 'white',
                          fontSize: '1.0625rem'
                        }}
                      >
                        +255 737 957082 / +255 719 579733
                      </p>
                    </div>
                  </div>
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-map-marker-alt mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Address
                      </p>
                      <p 
                        className="text-white"
                        style={{
                          color: 'white',
                          fontSize: '1.0625rem',
                          lineHeight: '1.75'
                        }}
                      >
                        8th Floor, Victoria House, Mikocheni,<br />Dar es Salaam, Tanzania
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
